





































































































































































































































































































































































































































































import PageLayout from '@/components/page/PageLayout.vue'
import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import cloneDeep from 'lodash/cloneDeep'
import isEmpty from 'lodash/isEmpty'
import TaskApi from '@/api/task'
import { checkCarNo, debounce } from '@/utils/util'
import addTaskMixin from './addTaskMixin'
import { RESURVEY } from '@/utils/const'
let id: any = 0

const debounceSearch = debounce(300)

@Component({
	components: {
		VNodes: {
			functional: true,
			render: (h: any, ctx: any) => ctx.props.vnodes,
		},
	},
})
export default class Resurvey extends Mixins(addTaskMixin) {
	public taskType: any = RESURVEY
}
